import styled from 'styled-components';

const ButtonInputComment = styled.button`
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  font-size: 12px;
  width: 100%;
  padding: 12px;
  border: 0;
  border-radius: 8px;
  background-color: var(--on-background);
  color: var(--background);
  cursor: pointer;
`;

export default ButtonInputComment;
